module.exports = __webpack_public_path__ + "img/gear-E-high_72x72.a6b71f4d.png";